import React, { Component } from 'react';
import { Card, Badge, ListGroup, ListGroupItem, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    EMPLOYEE_COUNT,
    OVERRIDE_POINTS,
    PARTICIPATION,
    REWARD_BUDGET
} from '../actions/types';

class Results extends Component {

    inBudget(cost) {
        const { rewardBudget } = this.props;
        if (cost > rewardBudget) {
            return <Badge className='float-right' variant="danger">Over Budget</Badge>;
        } else {
            return <Badge className='float-right' variant="success">In Budget</Badge>;
        }
    }

    render() {
        const {
            employeeCount,
            overridePoints,
            participation,
            valueAveTenure,
            valueMaxNoCallOffs,
            valueMaxOnTime,
            valueMaxShiftsPickedUp,
            valueMaxSurvey,
            valueMaxTotalPoints,
            valueMaxTotalPointsEst,
            valueOverrideRewardsEst,
            valueOverrideRewardsPerMonth,
            valueOverrideRewardsPerMonthDistributed,
            valueOverrideRewardsPerMonthStyle,
            valueOverrideRewardsValueEst,
            valueOverrideRewardsWithManualAwardsValueEst,
            valuePointsPerReward,
            valueRewardsDistributedEst,
            valueRewardsDistributedValueEst,
            valueRewardsDistributedValueWithManualAwardsEst,
            valueRewardsPerMonth,
            valueRoundedPointsPerReward,
            valueRoundedPointsPerRewardDistributed
        } = this.props;
        return (
            <div>
                <Card>
                    <Card.Header>Distribute Based Upon Budget</Card.Header>
                    <ListGroup className='budget-summary'>
                        <ListGroupItem>Max Total Rewards Distributed Per Month: {valueRewardsPerMonth.toFixed(2)}</ListGroupItem>
                        <ListGroupItem variant="info"><strong>Exact Number of Points Per Reward: {valuePointsPerReward.toFixed(2)}</strong></ListGroupItem>
                        <ListGroupItem>Rounded of Points Per Reward: {valueRoundedPointsPerReward.toFixed(2)}</ListGroupItem>
                        <ListGroupItem variant="success">Estimated Budget based on rounded value: ${valueRoundedPointsPerRewardDistributed.toFixed(2)} {this.inBudget(valueRoundedPointsPerRewardDistributed)}</ListGroupItem>
                        <ListGroupItem variant="warning">{participation.toFixed(0)}% Part. Estimated Rewards Distributed: {valueRewardsDistributedEst.toFixed(2)}</ListGroupItem>
                        <ListGroupItem variant="warning">{participation.toFixed(0)}% Part. Estimated Budget: ${valueRewardsDistributedValueEst.toFixed(2)} {this.inBudget(valueRewardsDistributedValueEst)}</ListGroupItem>
                        {/*Need to insert calculation value*/}
                        <ListGroupItem variant="warning">Extra Dollars Spent Based on Manual Awards: ${valueRewardsDistributedValueWithManualAwardsEst.toFixed(2)} </ListGroupItem>
                    </ListGroup>
                </Card>
                <Card>
                    <Card.Header>Distribution Based Upon Overridden Points Value</Card.Header>
                    <ListGroup className='budget-summary'>
                        <ListGroupItem>Estimated Maximum Rewards Distributed Per Month: {valueOverrideRewardsPerMonth.toFixed(2)}</ListGroupItem>
                        <ListGroupItem variant="info"><strong>Specified Number of Points Per Reward: {overridePoints.toFixed(2)}</strong></ListGroupItem>
                        <ListGroupItem variant={valueOverrideRewardsPerMonthStyle}><strong>Estimated Total Cost Per Month: ${valueOverrideRewardsPerMonthDistributed.toFixed(2)} {this.inBudget(valueOverrideRewardsPerMonthDistributed)}</strong></ListGroupItem>
                        <ListGroupItem variant="warning">{participation.toFixed(0)}% Part. Estimated Manual Rewards Distributed: {valueOverrideRewardsEst.toFixed(2)}</ListGroupItem>
                        <ListGroupItem variant="warning">{participation.toFixed(0)}% Part. Estimated Overridden Budget: ${valueOverrideRewardsValueEst.toFixed(2)} {this.inBudget(valueOverrideRewardsValueEst)}</ListGroupItem>
                        <ListGroupItem variant="warning">Extra Dollars Spent Based on Manual Awards: ${valueOverrideRewardsWithManualAwardsValueEst.toFixed(2)}</ListGroupItem>
                    </ListGroup>
                </Card>
                <Card>
                    <Card.Header>Reward Points Calculation Summary</Card.Header>
                    <Card.Body>
                        <Table striped bordered condensed='true' hover>
                            <thead>
                                <tr>
                                    <th width="50%">Reward Points Calculated Values</th>
                                    <th width="25%">Total</th>
                                    <th width="25%">Per Employee</th>
                                </tr>
                            </thead>
                            <tbody >
                                <tr>
                                    <td>Average Total Monthly Tenure Reward:</td>
                                    <td>{valueAveTenure.toFixed(2)}</td>
                                    <td>{(valueAveTenure / employeeCount).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Max Total Monthly No Call-Off Reward:</td>
                                    <td>{valueMaxNoCallOffs.toFixed(2)}</td>
                                    <td>{(valueMaxNoCallOffs / employeeCount).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Max Total Monthly On-Time Reward:</td>
                                    <td>{valueMaxOnTime.toFixed(2)}</td>
                                    <td>{(valueMaxOnTime / employeeCount).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Max Total Monthly Shifts Picked Up Reward:</td>
                                    <td>{valueMaxShiftsPickedUp.toFixed(2)}</td>
                                    <td>{(valueMaxShiftsPickedUp / employeeCount).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Max Total Monthly Survey Reward:</td>
                                    <td>{valueMaxSurvey.toFixed(2)}</td>
                                    <td>{(valueMaxSurvey / employeeCount).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Max Total Monthly Reward:</td>
                                    <td>{valueMaxTotalPoints.toFixed(2)}</td>
                                    <td>{(valueMaxTotalPoints / employeeCount).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>{participation.toFixed(0)}% Participation Estimated Monthly Reward:</td>
                                    <td>{valueMaxTotalPointsEst.toFixed(2)}</td>
                                    <td>{(valueMaxTotalPointsEst / employeeCount).toFixed(2)}</td>
                                </tr>
                            </tbody>
                        </Table>
                        <ListGroup className='calc-estimates'>
                            <ListGroupItem>Minimum months between rewards for employee: {(overridePoints / (valueMaxTotalPoints / employeeCount)).toFixed(2)}</ListGroupItem>
                            <ListGroupItem>Estimated months based on participation: {(overridePoints / (valueMaxTotalPointsEst / employeeCount)).toFixed(2)}</ListGroupItem>
                        </ListGroup>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

Results.propTypes = {
    employeeCount: PropTypes.number,
    overridePoints: PropTypes.number,
    participation: PropTypes.number,
    rewardBudget: PropTypes.number,
    valueAveTenure: PropTypes.number,
    valueMaxNoCallOffs: PropTypes.number,
    valueMaxOnTime: PropTypes.number,
    valueMaxShiftsPickedUp: PropTypes.number,
    valueMaxSurvey: PropTypes.number,
    valueMaxTotalPoints: PropTypes.number,
    valueMaxTotalPointsEst: PropTypes.number,
    valueOverrideRewardsEst: PropTypes.number,
    valueOverrideRewardsPerMonth: PropTypes.number,
    valueOverrideRewardsPerMonthDistributed: PropTypes.number,
    valueOverrideRewardsPerMonthStyle: PropTypes.string,
    valueOverrideRewardsValueEst: PropTypes.number,
    valueOverrideRewardsWithManualAwardsValueEst: PropTypes.number,
    valuePointsPerReward: PropTypes.number,
    valueRewardsDistributedEst: PropTypes.number,
    valueRewardsDistributedValueEst: PropTypes.number,
    valueRewardsDistributedValueWithManualAwardsEst: PropTypes.number,
    valueRewardsPerMonth: PropTypes.number,
    valueRoundedPointsPerReward: PropTypes.number,
    valueRoundedPointsPerRewardDistributed: PropTypes.number
};

function mapStateToProps(state) {
    return {
        employeeCount: state.calc.get(EMPLOYEE_COUNT),
        overridePoints: state.calc.get(OVERRIDE_POINTS),
        participation: state.calc.get(PARTICIPATION),
        rewardBudget: state.calc.get(REWARD_BUDGET),
        valueAveTenure: state.calc.get('valueAveTenure'),
        valueMaxNoCallOffs: state.calc.get('valueMaxNoCallOffs'),
        valueMaxOnTime: state.calc.get('valueMaxOnTime'),
        valueMaxShiftsPickedUp: state.calc.get('valueMaxShiftsPickedUp'),
        valueMaxSurvey: state.calc.get('valueMaxSurvey'),
        valueMaxTotalPoints: state.calc.get('valueMaxTotalPoints'),
        valueMaxTotalPointsEst: state.calc.get('valueMaxTotalPointsEst'),
        valueOverrideRewardsEst: state.calc.get('valueOverrideRewardsEst'),
        valueOverrideRewardsPerMonth: state.calc.get('valueOverrideRewardsPerMonth'),
        valueOverrideRewardsPerMonthDistributed: state.calc.get('valueOverrideRewardsPerMonthDistributed'),
        valueOverrideRewardsPerMonthStyle: state.calc.get('valueOverrideRewardsPerMonthStyle'),
        valueOverrideRewardsValueEst: state.calc.get('valueOverrideRewardsValueEst'),
        valueOverrideRewardsWithManualAwardsValueEst: state.calc.get('valueOverrideRewardsWithManualAwardsValueEst'),
        valuePointsPerReward: state.calc.get('valuePointsPerReward'),
        valueRewardsDistributedEst: state.calc.get('valueRewardsDistributedEst'),
        valueRewardsDistributedValueEst: state.calc.get('valueRewardsDistributedValueEst'),
        valueRewardsDistributedValueWithManualAwardsEst: state.calc.get('valueRewardsDistributedValueWithManualAwardsEst'),
        valueRewardsPerMonth: state.calc.get('valueRewardsPerMonth'),
        valueRoundedPointsPerReward: state.calc.get('valueRoundedPointsPerReward'),
        valueRoundedPointsPerRewardDistributed: state.calc.get('valueRoundedPointsPerRewardDistributed')
    };
}

export default connect(mapStateToProps, {})(Results);
